import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAvalancheAdvisoryState, IAvalancheData, LoadState } from 'redux-state/avalanche-advisory/types.js';

const initialState: IAvalancheAdvisoryState = {
  data: undefined,
  loadState: undefined,
};

export const avalancheAdvisorySlice = createSlice({
  name: 'avalancheAdvisory',
  initialState,
  reducers: {
    REDUX_AVALANCHE_ADVISORY_FETCH: (state) => {
      return { ...state, loadState: LoadState.LOADING };
    },
    REDUX_AVALANCHE_ADVISORY_FETCH_SUCCESS: (state, action: PayloadAction<IAvalancheData>) => {
      return { ...state, data: action.payload, loadState: LoadState.SUCCESS };
    },
    REDUX_AVALANCHE_ADVISORY_FETCH_ERROR: (state) => {
      return { ...state, loadState: LoadState.ERROR };
    },
  },
});
export const {
  REDUX_AVALANCHE_ADVISORY_FETCH,
  REDUX_AVALANCHE_ADVISORY_FETCH_SUCCESS,
  REDUX_AVALANCHE_ADVISORY_FETCH_ERROR,
} = avalancheAdvisorySlice.actions;

export const avalancheAdvisory = avalancheAdvisorySlice.reducer;
